import styled from 'styled-components'

export const SharedCarouselStyled = styled.div`
  width: 100%;
`
